/* eslint-disable */
import React, { Component } from "react";
import MediaQuery from "react-responsive";
import store from "../state/store";
import PathogenicityPill from "./atoms/PathogenicityPill/PathogenicityPill";
import { RenderUrl } from "./atoms/RenderUrl";
import { httpRequest } from "../services/http";
import helpers from "../common/utils/utils";
import PubmedForm from "./PubmedUserEntries/PubmedForm";
import SSOUser from "./social/SSOUser";
import ClassificationModal from "../pages/variant/components/ClassificationModal/ClassificationModal";

const getRepresentationLink = (repr) => {
  if (repr) {
    return repr.replace("⇒", "-");
  }
  return "";
};

export const RenderRecentActivities = ({
  activities,
  separator,
  renderDate,
  userId,
}) => {
  return (
    <>
      {activities.map((a, i) => (
        <div key={i} className="recent-activity-item">
          {separator && i > 0 && <hr />}
          {a.action_type === "publication" && (
            <div className="tw-relative">
              <i className="fa fa-bookmark-o" />
              <span className="tw-px-2">
                <SSOUser ssoId={a.user__open_id_identifier_hashed || userId} />
              </span>
              <span>
                linked the publication <em>'{a.title}'</em> to&nbsp;
              </span>
              {a.representation.map((repr, i) => {
                if (i === 3) return "and more...";
                if (i > 3) return null;
                return (
                  <span key={i}>
                    <RenderUrl
                      url={`${store.getState().varsomeHost}/variant/${
                        a.ref_genome[i]
                      }/${getRepresentationLink(repr)}#community-contributions`}
                      label={repr}
                    />
                    {i < a.representation.length - 1 && ", "}
                  </span>
                );
              })}
              {renderDate && (
                <div className="varsome-text-muted tw-text-sm tw-ml-5">
                  {helpers.parseDateTime(a.created_at)}
                </div>
              )}
              {a.can_edit && (
                <div className="tw-absolute tw-right-0 tw-top-1">
                  <PubmedForm entry={a} isEdit={true} linkText="Edit" />
                </div>
              )}
            </div>
          )}
          {a.action_type === "flag" && (
            <div className="tw-relative">
              <i className="fa fa-flag-o" />
              <span className="tw-px-1">
                <SSOUser ssoId={a.user__open_id_identifier_hashed || userId} />
              </span>
              classified{" "}
              <RenderUrl
                url={`${store.getState().varsomeHost}/variant/${
                  a.ref_genome[0]
                }/${getRepresentationLink(
                  a.representation[0]
                )}#community-contributions`}
                label={a.representation[0]}
              />
              &nbsp; as&nbsp;
              <PathogenicityPill pathogenicity={a.flag} />
              {renderDate && (
                <div
                  className="varsome-text-muted tw-text-sm"
                  style={{ marginLeft: "1.2rem" }}
                >
                  {helpers.parseDateTime(a.created_at)}
                </div>
              )}
              {a.can_edit && (
                <div className="tw-absolute tw-right-0 tw-top-1">
                  <ClassificationModal userFlag={a} variantId={a.object_id} />
                </div>
              )}
            </div>
          )}
        </div>
      ))}
    </>
  );
};

export default class RecentActivity extends Component {
  constructor() {
    super();
    this.componentName = "RecentActivity";
  }

  componentDidMount() {
    this.mapStoreToState(store.getState());
    this.subscription = store.subscribe(() => {
      this.mapStoreToState(store.getState());
    });
    $(window).on("scroll.recent_activity", this.getStyle.bind(this));
    $(window).on("resize.recent_activity", this.getStyle.bind(this));
    this.getStyle();
    this.getRecentActivity();
  }

  componentWillUpdate(nextProps, nextState) {
    const { variantResult } = this.state;
    if (!variantResult && nextState.variantResult) {
      this.getStyle();
    }
  }

  componentWillUnmount() {
    this.subscription();
    $(window).off("scroll.recent_activity");
    $(window).off("resize.recent_activity");
  }

  getStyle() {
    /* Calculate Recent Activity height */

    const windowHeight = window.outerHeight;
    const sidebarNavHeight = document.getElementById("nav-side").offsetHeight;
    let recentActivityHeight = windowHeight - sidebarNavHeight;

    /* 140 is the minimum height for one entry to appear in recent activity table. */
    if (recentActivityHeight < 140) {
      recentActivityHeight = 140;
    }

    setTimeout(() => {
      this.setState({ style: { height: `${recentActivityHeight}px` } });
    });
  }

  getRecentActivity() {
    const state = store.getState();
    const url = `${state.apiUrl}/recent_activity/`;
    httpRequest
      .get(url)
      .then((response) => {
        const recentActivity = response.data;
        this.getStyle();
        this.setState({ recentActivity });
      })
      .catch((error) => {
        console.error("While getting recent activity:", error);
      });
  }

  mapStoreToState(storeState) {
    this.setState({
      variantClasses: storeState.variantClasses,
      initialDataLoaded: storeState.initialDataLoaded,
      variantResult: storeState.variantResult,
    });
  }

  render() {
    let tmpl = null;
    const { recentActivity, initialDataLoaded, style } = this.state;

    if (recentActivity && initialDataLoaded) {
      const res = recentActivity;

      tmpl = (
        <MediaQuery minWidth={992}>
          <div className="floating-panel recent-activity" style={style}>
            <div className="floating-panel-header">
              <h5>Recent VarSome activity</h5>
            </div>
            <RenderRecentActivities activities={res} />
          </div>
        </MediaQuery>
      );
    }
    return tmpl;
  }
}
